import { Component, OnInit,Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-manage',
  templateUrl: './manage.component.html',
  styleUrls: ['./manage.component.scss'],
})
export class ManageComponent implements OnInit {


  is_editing = false;
  tags: any = [];
  @Input() url = 'clients';
  @Input() title = '';
  @Input() url_base = 'tags';

  roles: any = [];

  add_tag = {
    guid: '',
    title: '',
    colour: '#90ee90',
    description: '',
    parent_guid: ''
  }


  constructor(public modalController: ModalController, private apiService: ApiService, public globalService: GlobalService) { }

  // Same rule as the API: groups use groups_*, the *_internal_status tables use statuses_*, everything else
  // (tags, skills, communication types...) uses tags_*
  Can(action: 'create' | 'update' | 'delete'): boolean {
    let prefix = 'tags_';
    if (this.url_base === 'groups') prefix = 'groups_';
    else if ((this.url || '').endsWith('_internal_status')) prefix = 'statuses_';
    else if (this.url === 'time_and_billing') prefix = 'time_tags_';
    return this.globalService.Can(prefix + action);
  }

  ngOnInit() {
    this.GetData();
  }

  async GetData() {
    let data: any = await this.apiService.get(`${this.url_base}/${this.url}`);
    this.tags = data.data;
    if(this.tags === null) return;
  }

  async Cancel() {
    this.modalController.dismiss(null);
  }

  async Create() {
    this.globalService.presentLoading("Creating...",9999);
    let data: any = await this.apiService.post(`${this.url_base}/${this.url}`,this.add_tag);
    this.globalService.presentToastMessage(data.message,data.success);
    await this.GetData();
    this.globalService.dismissLoading();
    this.CancelEdit();
  }

  async Update() {
    this.globalService.presentLoading("Updating...",9999);
    let data: any = await this.apiService.put(`${this.url_base}/${this.url}/${this.add_tag.guid}`, this.add_tag);
    this.globalService.presentToastMessage(data.message, data.success);
    await this.GetData();
    this.globalService.dismissLoading();
    this.CancelEdit();
  }
  async CancelEdit() {
    this.is_editing = false;
    this.add_tag = {
      guid: '',
      title: '',
      colour: '#90ee90',
      description: '',
      parent_guid: ''
    };
  }

  async EditTag(tag) {
    this.is_editing = true;
    this.add_tag = tag;

  }

  async Delete(tag) {
    let data: any = await this.apiService.delete(`${this.url_base}/${this.url}/${tag.guid}/${false}`, null);
    this.globalService.presentToastMessage(data.message, data.success);
    await this.GetData();
    this.CancelEdit();
  }

  async DeleteForce(tag) {
    //I need this to ask the user to enter the word delete first, if they enter delete, then we can delete the tag and remove it from all associated items
    const input = window.prompt('Please enter the word "delete" to confirm deletion.');
    if (input === 'delete') {
      let data: any = await this.apiService.delete(`${this.url_base}/${this.url}/${tag.guid}/${true}`, null);
      this.globalService.presentToastMessage(data.message, data.success);
      await this.GetData();
      this.CancelEdit();
    } else if (input && input !== 'delete') {
      this.globalService.presentToastMessage('You entered the wrong word.', false);
    }
  }

}
